export { default, SimulationScore } from './SimulationScore';
export type { SimulationScoreProps } from './types';